import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { name: 'Home', to: 'header' },
    { name: 'Products', to: 'products', badge: 'New' },
    { name: 'About', to: 'about' },
    { name: 'Services', to: 'services' },
    { name: 'Technologies', to: 'technologies' },
    { name: 'Solutions', to: 'solutions' },
    { name: 'Process', to: 'process' },
      { name: 'Projects', to: 'all-projects' },
    //{ name: 'Music', to: 'music' },
    { name: 'Contact', to: 'contact' }
  ];

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Main Navbar */}
      <nav className={`w-full transition-all duration-300 ${
        scrolled ? 'bg-forest/90 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link 
              to="header"
              spy={true}
              smooth={true}
              duration={500}
              className="cursor-pointer"
            >
              <img 
                src="/logo2.png" 
                alt="PlatypusBox Logo" 
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-cream hover:text-accent-green transition-colors cursor-pointer text-sm lg:text-base whitespace-nowrap"
                >
                  {item.name}
                  {item.badge && (
                    <span className="ml-1.5 align-middle text-[10px] font-bold uppercase bg-[#C4694A] text-white px-1.5 py-0.5 rounded-full">
                      {item.badge}
                    </span>
                  )}
                </Link>
              ))}
              <a
                href="https://app.platypusbox.com/#/login"
                target="_blank"
                rel="noopener noreferrer"
                className="text-forest bg-accent-green hover:bg-accent-green/90 px-4 py-2 rounded-md transition-colors cursor-pointer text-sm lg:text-base font-medium"
              >
                Login
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-cream hover:text-accent-green transition-colors"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu - Separate from main navbar */}
      <div 
        className={`absolute top-20 left-0 right-0 bg-forest transform transition-transform duration-300 ${
          isOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
        style={{
          visibility: isOpen ? 'visible' : 'hidden',
          transitionProperty: 'transform, visibility',
          transitionDuration: '300ms'
        }}
      >
        <div className="container mx-auto px-4 py-2">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.to}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="block py-3 text-cream hover:text-accent-green transition-colors cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              {item.name}
                  {item.badge && (
                    <span className="ml-1.5 align-middle text-[10px] font-bold uppercase bg-[#C4694A] text-white px-1.5 py-0.5 rounded-full">
                      {item.badge}
                    </span>
                  )}
            </Link>
          ))}
          <a
            href="https://app.platypusbox.com/#/login"
            target="_blank"
            rel="noopener noreferrer"
            className="block py-3 text-accent-green hover:text-accent-green/90 transition-colors cursor-pointer font-medium"
            onClick={() => setIsOpen(false)}
          >
            Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
